import { UserDetail } from './../../shared/models/userDetail.model';
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

export const GRAPH_ENDPOINT = 'https://graph.microsoft.com/v1.0/';

@Injectable({
  providedIn: 'root'
})
export class GraphApiService {

  constructor(private httpClient: HttpClient) { }

  // used to getting users as per given name
  public getUsers(givenName?: string): Observable<UserDetail[]> {
    const selectedFields = 'department,onPremisesDomainName,mailNickname,onPremisesSamAccountName,businessPhones,displayName,givenName,jobTitle,mail,mobilePhone,officeLocation,preferredLanguage,surname,userPrincipalName,id,otherMails';
    return this.fetchData(`users?$select=${selectedFields}&$filter=startswith(givenName,\'${givenName}\') or startswith(displayName,\'${givenName}\') or startswith(surname,\'${givenName}\') or startswith(mail,\'${givenName}\') or startswith(userPrincipalName,\'${givenName}\')`)
      .pipe(map(response => {
      let users = [];
        if (response.value && response.value.length) {
          console.log(response.value);
        users = response.value.filter((x: UserDetail) => {
          // Commented below code to add the external users other than BHP doamin users
          //return x.onPremisesDomainName !== null && x.onPremisesSamAccountName !== null && x.userPrincipalName !== null;          
          return x.userPrincipalName !== null;
        });
      }
      return users;
    }));
  }

  // used to get manager details as per user id
  public getManagerDetailsOfUser(userID: string): Observable<UserDetail> {
    return this.fetchData(`users/${userID}/manager`);
  }

  public handleError(error: HttpErrorResponse): any {
    let errorMessage = 'Unknown error!';
    if (error.error instanceof ErrorEvent) {
      // Client-side errors
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // Server-side errors
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(errorMessage);
  }

  public fetchData(url: string): Observable<any>{
    return this.httpClient.get(`${GRAPH_ENDPOINT}${url}`).pipe(catchError(this.handleError));
  }
}
